import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../../types/state';
import { TLocale } from '../../types/locale';

const setLocale = (state: IState, action: PayloadAction<TLocale>) => {
  state.i18n.locale = action.payload;
};

export default setLocale;
